import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React, { useEffect } from 'react';

import { OperationType } from '../../../../../../../../../components/OperationType';
import { useDirectTreasurySellAssetController } from '../../../../../hooks/products/DirectTreasurySell';
import { LateralBar } from '../../../components/LateralBar';

import { DirectTreasuryItemSelectedTypes, directTreasuryRescueNoticeMessage } from '.';

export const DirectTreasuryItemSelectedMobile: React.FC<DirectTreasuryItemSelectedTypes.Props> = ({
  offer,
  onUpdate,
  hideLateralBar = false,
}) => {
  const id = offer.titleId;
  const { amountItem, amountValue, amountValueFormatted, handleChangeAmountItem } =
    useDirectTreasurySellAssetController(offer);

  useEffect(() => {
    if (offer.orderQuantity === amountItem || !amountItem) {
      return;
    }
    const updatedOffer = {
      ...offer,
      orderQuantity: amountItem || 0.01,
      orderValue: amountValue,
    };
    onUpdate(updatedOffer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amountItem]);

  const middleInfos = [
    {
      label: 'Tipo',
      value: <OperationType title="Resgate" />,
    },
    {
      label: 'Quantidade disponível',
      value: <UI.Text color="neutral.dark">{offer.quantityAvailableFormatted}</UI.Text>,
    },
    {
      label: 'Valor estimado',
      value: <UI.Text color="neutral.dark">{amountValueFormatted}</UI.Text>,
    },
    {
      label: 'Disponível em conta',
      value: (
        <UI.Text color="neutral.dark">
          {offer.redemptionDate ? Utils.Mask.DateFormat(offer.redemptionDate, 'dd/MM/yyyy') : '--'}
        </UI.Text>
      ),
    },
  ];

  return (
    <VStack space="stack.xxxs" w="full">
      {!hideLateralBar && (
        <LateralBar
          backgroundColor="product.rf"
          borderTopLeftRadius={BoxRadius.sm}
          borderBottomLeftRadius={BoxRadius.sm}
        />
      )}
      <UI.Notice
        key="notice-direct-treasury-rescue"
        backgroundColor={Utils.ColorToken.WithOpacity('feedback.attention.lightest', 0.4)}
        textObjects={directTreasuryRescueNoticeMessage}
      />
      <VStack space="stack.nano">
        <UI.Text variant="semibold" color="neutral.black">
          {offer.productNameNormalized}
        </UI.Text>
      </VStack>
      <VStack space="stack.nano" flexGrow={1}>
        {middleInfos.map(({ label, value }) => (
          <HStack space="inline.quarck" justifyContent="space-between" key={label}>
            <UI.Text color="neutral.black" variant="semibold">
              {label}
            </UI.Text>
            {value}
          </HStack>
        ))}
      </VStack>
      <VStack space={Spacing['stack.quarck']} flexGrow={1}>
        <UI.Text color="neutral.black" variant="semibold">
          Quantidade
        </UI.Text>
        <VStack flex={1}>
          <UI.InputStepper
            stepperValue={0.01}
            max={offer.availableQuantity}
            min={offer.minimumStepQuantity || 0}
            name={`treasury-amount-order-input-${id}`}
            keyboardType="numeric"
            fontSize={Typography['fontsize.md']}
            defaultValue={amountItem || 0}
            onChange={handleChangeAmountItem}
            showErrorMessage={false}
          />
        </VStack>
      </VStack>
    </VStack>
  );
};
